/* eslint-disable react-hooks/exhaustive-deps */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useEffect, useState } from "react";
import { PrimaryButton } from "../../components";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevrons/chevron-down.svg";
import { BeevisionDropsTable } from "./BeevisionDropsTable";
import { useBeevisionDrops } from "../../store/useBeevisionDrops";

function BeevisionDropsScreen() {
  /** Hooks */
  const {
    downloadBeevisionDropsInCSV,
    beevisionDrops,
    getBeevisionDrops,
    hasNextPage,
  } = useBeevisionDrops();
  /** State */
  const [page, setPage] = useState(1);

  /** Effects */
  useEffect(() => {
    getBeevisionDrops(page, 20);
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Beevision Drops
        </h1>
        <div className="flex flex-col sm:flex-row">
          <Menu>
            <MenuHandler>
              <button className="h-8 bg-droppie-oranje px-6 border border-gray-border rounded font-satoshi text-base text-white font-medium flex items-center justify-center mb-1 sm:mb-0">
                Download
                <ChevronDown className="ml-2 *:fill-white stroke-white fill-white" />
              </button>
            </MenuHandler>
            <MenuList placeholder={undefined}>
              <MenuItem
                onClick={downloadBeevisionDropsInCSV}
                className="font-satoshi text-base text-dark"
                placeholder={undefined}
              >
                Download in CSV
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!beevisionDrops?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Beevision drop created yet.
          </p>
        ) : (
          <BeevisionDropsTable />
        )}
      </div>
      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getBeevisionDrops(page + 1, 20);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(BeevisionDropsScreen);
